import type React from 'react';
import { useContext, useState } from 'react';
import { ConfigContext } from '../context/ConfigContext';
import { sendRestartRequest } from '../services/postMessageService';
import PoweredBy from './PoweredBy';

type TBlockerProps = { onEnableChat: () => void };

export const Blocker: React.FC<TBlockerProps> = ({ onEnableChat }) => {
  const {
    blockerConfig,
    scheme: {
      message: {
        buttonEdgeColor,
        buttonTextColor,
        buttonHoverColor,
        buttonBackgroundColor,
      },
    },
  } = useContext(ConfigContext);
  const { text, buttonText } = blockerConfig;
  const [hover, setHover] = useState(false);

  return (
    <div className='chat-window-blocker-container'>
      <p className='chat-window-blocker-text'>{text}</p>
      <button
        type='button'
        className='button-outline'
        onMouseEnter={() => setHover(!hover)}
        onMouseLeave={() => setHover(!hover)}
        onClick={() => {
          sendRestartRequest();
          onEnableChat();
        }}
        style={{
          color: hover ? buttonHoverColor : buttonTextColor,
          borderColor: hover ? buttonHoverColor : buttonEdgeColor,
          backgroundColor: buttonBackgroundColor,
        }}>
        {buttonText}
      </button>
      <PoweredBy />
    </div>
  );
};
